import { MemberRegistrationUserType } from "../Helpers/Enums/MemberRegistrationUserType";
import { RoleEnum } from "../Helpers/Enums/RoleEnum";

export interface CheckUserCredentialsModel {
  Status: boolean;
  Code: CheckUserCredentialsCode | Number;
  Message: string;
  UserDetails: UserDetails;
}

export interface UserDetails {
  Id: Number;
  UserGuid: string;
  EmployeeNo: string;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  EmailId: string;
  ContactNo: string;
  LoginId: string;
  MemberId: Number;
  MemberNo: Number;
  Roles: RoleModel[];
  Permissions: PermissionModel[];
  CurrentRoleId: RoleEnum;
  UnitCodeId: string;
  UnitCodeIds: string;
  loggedInAs: any;
  UserType: MemberRegistrationUserType | Number;
  IsSuretyReplaced: boolean;
}

export interface PermissionModel {
  Role: string;
  SystemName: string;
}
export interface RoleModel {
  RoleId: number;
  RoleName: string;
  UnitCodes: string;
  unitcodenames: string;
}

export const enum CheckUserCredentialsCode {
  SuccessfulLogin = 2,
}
